module.exports = __webpack_public_path__ + "be-chat-icon.png?264d55987d56f1989eaf4998a5e05423";